import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import ViewTenantDetails from "components/ViewTenantDetails/ViewTenantDetails";
import EditTenantDetails from "components/EditTenantDetails/EditTenantDetails";
import { useFetchTenantDetails } from "store/backend/apiHooks";
import Loader from "shared/Icons/Loader/Loader";
import { Visibility, Edit } from "@mui/icons-material";
import { PrimaryButton } from "widgets";
import routes from "constants/routes";

import styles from "./TenantDetails.module.scss";

const TenantDetails = () => {
  const [searchParams] = useSearchParams();
  const tenantId = searchParams.get("tenantId");
  const [editTenant, setEditTenant] = useState(false);
  const { data: tenantDetails, isPending: isFetchTenantDetailsLoading } =
    useFetchTenantDetails(tenantId);

  if (isFetchTenantDetailsLoading) {
    return (
      <div className={styles.mainContainer}>
        <div
          className={styles.loadingWrap}
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <Loader inline />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.mainContainer}>

      <div className={styles.toolbar}>
        <Link className={styles.backLink} to={routes.tenants.tenants}>
          ← Back to tenants
        </Link>
        <h1 className={styles.pageTitle}>
          {editTenant ? "Edit tenant details" : "Tenant details"}
        </h1>
        <PrimaryButton
          className={styles.editButton}
          onClick={() => setEditTenant(!editTenant)}
        >
          {editTenant ? "View tenant" : "Edit tenant"}
          {editTenant ? (
            <Visibility className={styles.icon} />
          ) : (
            <Edit className={styles.icon} />
          )}
        </PrimaryButton>
      </div>
      <div className={styles.tenantDetailsContent}>
        {editTenant ? (
          <EditTenantDetails
            tenantDetails={tenantDetails}
            tenantId={tenantId}
            onViewDetails={() => setEditTenant(false)}
          />
        ) : (
          <ViewTenantDetails tenantDetails={tenantDetails} />
        )}
      </div>
    </div>
  );
};

export default TenantDetails;
